import { fulfilled, failed, pending } from "lib/promiseMiddlewareTypes";
import initialState from "store/initialState";
import { GET_CONFIG, UPDATE_CONFIG } from "actions/config";
import { omit } from "lodash";

const config = (state = initialState.config, action: any) => {
  switch (action.type) {
    case failed(GET_CONFIG):
    case pending(GET_CONFIG):
      return [];
    case fulfilled(GET_CONFIG):
    case fulfilled(UPDATE_CONFIG):
      return omit(action.payload, ["_id"]);
    default:
      return state;
  }
};

export default config;
